import type { StateView } from '@quiz/shared';
import type { PlayerSession } from '../lib/session.js';
import { Card, Logo } from '../components/ui.js';

/**
 * The holding area.
 *
 * Everyone who has paid and entered their code waits here. The whole quiz is
 * already downloaded to the phone, sealed -- when the host starts the first
 * round, the next poll drops them straight into question one.
 *
 * Deliberately almost empty: no prize, no round list, nothing to read ahead
 * about. It answers one question, "am I in?", and then gets out of the way.
 */
export function LobbyScreen({ session, state }: { session: PlayerSession; state: StateView }) {
  return (
    <div className="flex flex-1 flex-col gap-4">
      <Logo className="mt-2 h-16" />

      <Card className="text-center">
        <p className="text-xs uppercase tracking-wide text-muted">You&rsquo;re in as</p>
        <p className="mt-1 text-3xl font-bold">{session.callSign}</p>
      </Card>

      <Card className="text-center">
        <p className="text-4xl font-bold tabular-nums">{state.playerCount}</p>
        <p className="text-sm text-muted">
          {state.playerCount === 1 ? 'player waiting' : 'players waiting'}
        </p>
      </Card>

      <div className="flex flex-1 flex-col items-center justify-center gap-2 text-center">
        <p className="animate-pulse text-lg text-muted">Waiting for the host to start…</p>
        <p className="text-sm text-muted">
          Keep this page open. The first question will appear here.
        </p>
      </div>
    </div>
  );
}
